// TODO: should not be dependent on vanillelightbox css in theme css

import CarouselSlider from './carousel';
import LotStateFilter from './lot-state-filter';

import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.css';
function SituatieKaart(htmlElements, options){
	this.htmlElements = htmlElements;

	this.viewerElement = null;
	this.currentElement = null;
	this.closeInfoWindowElement = null;
	this.currentContentElement = null;
	this.currentLayout;

	//default options
	this.options = {
		showLegenda: true,
		layoutSwitchWidth: 1056,
		showPopup: false,
		showDocuments: false,
		defaultLegendaStatus: 'inactive',
		fields: [
			'bouwnummer',
			'woningsoort',
			'kaveloppervlakte',
			'prijs',
			'status'
		],
		fieldsPopup: [
			'bouwnummer',
			'woningsoort',
			'kaveloppervlakte',
			'woningoppervlakte',
			'balkonoppervlakte',
			'inhoud',
			'prijs',
			'status'
		]
	};

	//voeg input opties samen met default opties
	for (var attrname in options) { this.options[attrname] = options[attrname]; }

	this.bouwnummers = [];

	// bind functions
	this.activateInfoWindow = this.activateInfoWindow.bind(this);
	this.deactivateInfoWindow = this.deactivateInfoWindow.bind(this);
	this.setupKaart = this.setupKaart.bind(this);
	this.setInfoWindow = this.setInfoWindow.bind(this);
	this.openFullInfoWindow = this.openFullInfoWindow.bind(this);
	this.toggleLotStatusVisibility = this.toggleLotStatusVisibility.bind(this);
	this.removeFullInfoWindow = this.removeFullInfoWindow.bind(this);
	this.onResizeLayout = this.onResizeLayout.bind(this);
	this.openViewer = this.openViewer.bind(this);
	this.removeViewer = this.removeViewer.bind(this);

	this.setLoadingStatus();

	this.parseKavels = this.parseKavels.bind(this);
	this.parseKavelsRequest = new XMLHttpRequest();
	this.parseKavelsRequest.addEventListener('readystatechange', this.parseKavels);

	let url = ajax_url_get_lots;

	const projectId = this.htmlElements.kaartElement.getAttribute('data-project-id');

	if (projectId) {
		url = url.match(/\?/) ? url + '&project_id=' + projectId : url + '?project_id=' + projectId;
	}

	this.parseKavelsRequest.open('GET', url);
	this.parseKavelsRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	this.parseKavelsRequest.send();
}

SituatieKaart.prototype.getFeaturedImage = function(images) {
	if (!Array.isArray(images)) {
		return false;
	}

	const featuredImages = images.filter(image => image.featured);

	return featuredImages.length > 0 ? featuredImages[0] : false;
};

SituatieKaart.prototype.setLoadingStatus = function(){
	this.htmlElements.kaartElement.classList.add('is-loading');
	this.htmlElements.mapElement.classList.add('is-loading');
};

SituatieKaart.prototype.removeLoadingStatus = function(){
	this.htmlElements.kaartElement.classList.remove('is-loading');
	this.htmlElements.mapElement.classList.remove('is-loading');
};

SituatieKaart.prototype.setSvgLabel = function(element, bouwnummer){
	if (!element || element.nodeType !== 1){
		return;
	}

	while (element.firstChild){
		element.removeChild(element.firstChild);
	}

	element.appendChild(document.createTextNode(bouwnummer.data.number));
};

SituatieKaart.prototype.activateInfoWindow = function(){
	this.infoWindowElement.classList.add('is-active');
};

SituatieKaart.prototype.deactivateInfoWindow = function(){
	this.infoWindowElement.classList.remove('is-active');
};

SituatieKaart.prototype.parseKavels = function(){
	if (this.parseKavelsRequest.readyState != 4) return;
	if (this.parseKavelsRequest.status != 200 && this.parseKavelsRequest.status != 304) {
		console.log('HTTP error ' + this.parseKavelsRequest.status);
		return;
	}

	if (!this.parseKavelsRequest.responseText){
		console.error('Kan kavel data niet ophalen');
	}

	this.removeLoadingStatus();

	const kavelData = JSON.parse(this.parseKavelsRequest.responseText);
	const kavelElements = this.htmlElements.mapElement.getElementsByTagName('a');

	var aKavelNo = false;
	var iKavelNo = false;

	for (var i=0;i<kavelElements.length;i++) {
		for (var j=0;j<kavelData.length;j++) {
			if (kavelElements[i].getAttribute('data-kavel')){
				aKavelNo = kavelElements[i].getAttribute('data-kavel').toLowerCase();
			}
			else {
				aKavelNo = false;
			}
			if (kavelData[j].number){
				iKavelNo = kavelData[j].number.toLowerCase();
			}
			else {
				iKavelNo = false;
			}

			if (aKavelNo && iKavelNo && aKavelNo === iKavelNo){
				this.bouwnummers.push(
					{
						data: kavelData[j],
						element: kavelElements[i]
					}
				);
			}
		}
	}

	for (let i=0;i<this.bouwnummers.length;i++){
		this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].data.status.value);
		this.bouwnummers[i].element.setAttribute('data-status', this.bouwnummers[i].data.status.value);

		if (this.options.defaultLegendaStatus === 'available-active' && this.bouwnummers[i].data.status.value === 'available' || this.options.defaultLegendaStatus === 'active') {
			this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class') + ' is-active');
		}

		// search for label elements
		const textElement = this.bouwnummers[i].element.querySelector('.s-popup-bouwnummer text');
		if (textElement){
			this.setSvgLabel(textElement, this.bouwnummers[i]);
		}
	}

	this.bouwnummers.sort((a, b) => {
		const c = parseInt(a.data.number, 10);
		const d = parseInt(b.data.number, 10);

		if (c < d){
			return -1;
		}
		if (c > d){
			return 1;
		}

		return 0;
	});

	this.setupKaart();
};

SituatieKaart.prototype.setupKaart = function(e) {
	this.htmlElements.mapElement.addEventListener('click', this.setInfoWindow);

	if (this.options.showPopup){
		this.fullInfoWindowElement = document.createElement('div');
		this.fullInfoWindowElement.setAttribute('class', 'kavelkaart-fullinfowindow');
		this.fullInfoWindowBackgroundElement = document.createElement('div');
		this.fullInfoWindowBackgroundElement.setAttribute('class', 'kavelkaart-fullinfowindow-background');
		this.fullInfoWindowBackgroundElement.addEventListener('click', this.removeFullInfoWindow);

		document.body.appendChild(this.fullInfoWindowElement);
		this.fullInfoWindowElement.appendChild(this.fullInfoWindowBackgroundElement);
	}

	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth){
		this.currentLayout = 'small';
		this.htmlElements.kaartElement.addEventListener('click', this.openViewer);
	}
	else {
		this.currentLayout = 'large';

		this.openViewer();
	}

	window.addEventListener('resize', this.onResizeLayout);//voor dynamisch switch layout

	document.addEventListener('keydown', function(e){
		if (e.keyCode == 27){
			this.removeViewer(e);
		}
	}.bind(this), false);

	if (this.bouwnummers[0] && this.currentLayout === 'large' && this.options.showBuildNumberWindow) {
		const availableBouwnummers = this.bouwnummers.filter(bouwnummer => bouwnummer.data.status.value === 'available');
		this.updateSelectedState(availableBouwnummers.length > 0 ? availableBouwnummers[0].element : this.bouwnummers[0].element);
		this.fillInfoWindow(availableBouwnummers.length > 0 ? availableBouwnummers[0].data : this.bouwnummers[0].data);
		this.activateInfoWindow();
	}
};

// TODO: no event als argument!
SituatieKaart.prototype.setInfoWindow = function(e) {
	let target = e.target;

	while (target.nodeName.toLowerCase() !== 'a'){
		if (target === this.infoWindowElement){
			return;
		}
		if (target === this.htmlElements.mapElement || target == this.closeInfoWindowElement){
			this.deactivateInfoWindow();
			this.updateSelectedState();
			return;
		}
		target = target.parentNode;
	}

	var kavelNo = target.getAttribute('data-kavel').toLowerCase();
	var kavelNoFound = false;
	for (var i=0;i<this.bouwnummers.length;i++){
		if (this.bouwnummers[i].data.number){
			var infoKavelNo = this.bouwnummers[i].data.number.toLowerCase();
		}
		if (infoKavelNo && kavelNo === infoKavelNo){
			this.fillInfoWindow(this.bouwnummers[i].data);
			kavelNoFound = true;
		}
	}

	if (kavelNoFound === false){
		this.fillInfoWindow(false);
	}

	this.updateSelectedState(target);

	this.activateInfoWindow();
};

SituatieKaart.prototype.updateSelectedState = function(kavelElement){
	for (let i=0; i<this.bouwnummers.length; i++){
		if (kavelElement && kavelElement === this.bouwnummers[i].element){
			if (this.bouwnummers[i].element.classList){//IE doesn't support classList in svg (?)
				this.bouwnummers[i].element.classList.add('is-selected');
			}
			else {
				if (this.bouwnummers[i].element.getAttribute('class')){
					this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class') + ' is-selected');
				}
				else {
					this.bouwnummers[i].element.setAttribute('class', 'is-selected');
				}
			}
		}
		else {
			if (this.bouwnummers[i].element.classList){//IE doesn't support classList in svg (?)
				this.bouwnummers[i].element.classList.remove('is-selected');
			}
			else {
				if (this.bouwnummers[i].element.getAttribute('class')){
					this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class').replace(/ is-selected/, ''));
				}
			}
		}
	}
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.fillInfoWindow = function(kavel) {
	while (this.infoWindowElement.firstChild){
		this.infoWindowElement.removeChild(this.infoWindowElement.firstChild);
	}

	let featuredImage = this.getFeaturedImage(kavel.houseModel.images);
	if (!featuredImage) {
		featuredImage = this.getFeaturedImage(kavel.images);
	}

	if (featuredImage && window.innerWidth && window.innerWidth >= this.options.layoutSwitchWidth){
		var imgElement = document.createElement('img');
		imgElement.setAttribute('src', featuredImage.src);

		if (kavel.woningtypeUrl){
			var aElementImage = document.createElement('a');
			aElementImage.setAttribute('href', kavel.woningtypeUrl);
			aElementImage.setAttribute('class', 'woningtype');

			aElementImage.appendChild(imgElement);
			this.infoWindowElement.appendChild(aElementImage);
		}
		else {
			imgElement.setAttribute('class', 'woningtype');
			this.infoWindowElement.appendChild(imgElement);
		}
	}

	var innerContentElement = document.createElement('div');
	innerContentElement.setAttribute('class', 'infowindow-inner');

	if (kavel == false){
		var h2Element = document.createElement('h2');
		h2Element.appendChild(document.createTextNode('Deze woning is nog niet in verkoop gegaan of is al verkocht.'));
		this.infoWindowElement.appendChild(h2Element);
		return;
	}

	var tableElement = document.createElement('table');

	var h2Element = document.createElement('h2');
	h2Element.appendChild(document.createTextNode(kavel.name));

	innerContentElement.appendChild(h2Element);

	if (kavel.number && this.options.fields.indexOf('bouwnummer') >= 0){
		tableElement.appendChild(this.createInfoRow('Bouwnummer', kavel.number));
	}
	if (kavel.houseModel?.name){
		tableElement.appendChild(this.createInfoRow('Woningtype', kavel.houseModel.name));
	}

	if (kavel.houseType && this.options.fields.indexOf('woningsoort') >= 0){
		tableElement.appendChild(this.createInfoRow('Woningsoort', kavel.houseType.label));
	}

	if (kavel.kaveloppervlakte && this.options.fields.indexOf('kaveloppervlakte') >= 0){
		const elementArray = [];
		const supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Kaveloppervlakte', kavel.kaveloppervlakte, false, elementArray));
	}
	if (kavel.woonoppervlakte && this.options.fields.indexOf('woonoppervlakte') >= 0){
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Woonoppervlakte', kavel.woonoppervlakte, false, elementArray));
	}
	if (kavel.inhoud && this.options.fields.indexOf('inhoud') >= 0){
		var elementArray = [];
		var supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('3'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Inhoud', kavel.inhoud, false, elementArray));
	}
	if (kavel.status && this.options.fields.indexOf('status') >= 0){
		tableElement.appendChild(this.createInfoRow('Status', kavel.status.label, false, false, kavel.status.value));
	}

	innerContentElement.appendChild(tableElement);

	if (kavel.priceRange && this.options.fields.indexOf('prijsbereik') >= 0) {
		const prijsElement = document.createElement('span');
		prijsElement.setAttribute('class', 'infowindow-prijs');
		prijsElement.appendChild(document.createTextNode('€' + String.fromCharCode(160) + kavel.priceRange.from + ' - €' + String.fromCharCode(160) + kavel.priceRange.to + String.fromCharCode(160) + kavel.priceCompositionSuffix));
		innerContentElement.appendChild(prijsElement);
	}

	if (parseInt(kavel.price, 10) > 0 && this.options.fields.indexOf('prijs') >= 0) {
		const prijsElement = document.createElement('span');
		prijsElement.setAttribute('class', 'infowindow-prijs');
		prijsElement.appendChild(document.createTextNode(kavel.priceFormattedWithComposition));
		innerContentElement.appendChild(prijsElement);
	}

	if (this.options.showPopup){
		var woningtypeButtonElement = document.createElement('button');
	}
	else if (kavel.woningtypeUrl){
		var woningtypeButtonElement = document.createElement('a');
	}

	if (this.options.showPopup || kavel.woningtypeUrl){
		woningtypeButtonElement.setAttribute('class', 'infowindow-button-woningtype button');
		woningtypeButtonElement.setAttribute('data-kavel', kavel.number);
		woningtypeButtonElement.appendChild(document.createTextNode('Bekijk deze woning'));
	}

	if (this.options.showPopup) {
		woningtypeButtonElement.addEventListener('click', this.openFullInfoWindow);
	}
	else if (kavel.woningtypeUrl) {
		woningtypeButtonElement.setAttribute('href', kavel.woningtypeUrl);
	}

	if (woningtypeButtonElement) {
		innerContentElement.appendChild(woningtypeButtonElement);
	}

	this.infoWindowElement.appendChild(innerContentElement);

	this.closeInfoWindowElement = document.createElement('button');
	this.closeInfoWindowElement.setAttribute('class', 'infowindow-close');

	this.infoWindowElement.appendChild(this.closeInfoWindowElement);

	this.closeInfoWindowElement.addEventListener('click', this.deactivateInfoWindow);
};

SituatieKaart.prototype.createInfoRow = function(label, data, prepend, append, className){
	var trElement1 = document.createElement('tr');
	if (className){
		trElement1.setAttribute('class', className.toLowerCase());
	}
	var tdElement1 = document.createElement('th');
	tdElement1.appendChild(document.createTextNode(label));
	var tdElement2 = document.createElement('td');
	tdElement2.appendChild(document.createTextNode(data));
	if (prepend){
		if (Array.isArray(prepend)){
			for (var i=0;i<prepend.length;i++){
				tdElement2.insertBefore(prepend[i], tdElement2.firstChild);
			}
		}
		else {
			tdElement2.insertBefore(prepend, tdElement2.firstChild);
		}
	}
	if (append){
		if (Array.isArray(append)){
			for (var i=0;i<append.length;i++){
				tdElement2.appendChild(append[i]);
			}
		}
		else {
			tdElement2.appendChild(append);
		}
	}

	trElement1.appendChild(tdElement1);
	trElement1.appendChild(tdElement2);

	return trElement1;
};

SituatieKaart.prototype.openFullInfoWindow = function(e) {
	let target = e.target;

	while (target.nodeName.toLowerCase() !== 'button'){
		if (target === this.fullInfoWindowElement){
			return;
		}
		if (target === this.htmlElements.mapElement || target === this.closeInfoWindowElement){
			this.deactivateInfoWindow();

			return;
		}
		target = target.parentNode;
	}

	var kavelNo = target.getAttribute('data-kavel').toLowerCase();
	var kavelNoFound = false;
	for (var i=0;i<this.bouwnummers.length;i++){
		if (this.bouwnummers[i].data.number){
			var infoKavelNo = this.bouwnummers[i].data.number.toLowerCase();
		}
		if (infoKavelNo && kavelNo === infoKavelNo){
			this.fillFullInfoWindow(this.bouwnummers[i].data);
			kavelNoFound = true;

			setTimeout( () => {
				new SimpleLightbox('.kavelkaart-fullinfowindow-slides a');
			}, 1000);
		}
	}

	this.fullInfoWindowElement.classList.add('is-active');
	this.fullInfoWindowBackgroundElement.classList.add('is-active');

	var offset =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	this.fullInfoWindowElement.setAttribute('style', 'top: ' + offset + 'px;');
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.fillFullInfoWindow = function(kavel) {
	if (this.fullInfoWindowElement.lastChild.classList.contains('kavelkaart-fullinfowindow-content')){
		this.fullInfoWindowElement.removeChild(this.fullInfoWindowElement.lastChild);
	}

	const contentElement = document.createElement('div');
	contentElement.setAttribute('class', 'kavelkaart-fullinfowindow-content');

	const headerElement = document.createElement('div');
	headerElement.setAttribute('class', 'kavelkaart-fullinfowindow-title');
	headerElement.appendChild(document.createTextNode('Kenmerken'));
	contentElement.appendChild(headerElement);

	const contentContainerElement = document.createElement('div');
	contentContainerElement.setAttribute('class', 'kavelkaart-fullinfowindow-content-container');

	const tableElement = document.createElement('table');
	tableElement.setAttribute('class', 'kavelkaart-fullinfowindow-bouwnummerinfo');

	if (kavel.number && this.options.fieldsPopup.indexOf('bouwnummer') >= 0) {
		tableElement.appendChild(this.createInfoRow('Bouwnummer', kavel.number));
	}
	if (kavel.houseModel?.name) {
		tableElement.appendChild(this.createInfoRow('Woningtype', kavel.houseModel.name));
	}
	if (kavel.houseType && this.options.fieldsPopup.indexOf('woningsoort') >= 0) {
		tableElement.appendChild(this.createInfoRow('Woningsoort', kavel.houseType.label));
	}

	if (kavel.kaveloppervlakte && this.options.fieldsPopup.indexOf('kaveloppervlakte') >= 0) {
		const elementArray = [];
		const supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Kaveloppervlakte', kavel.kaveloppervlakte, false, elementArray));
	}
	if (kavel.woonoppervlakte && this.options.fieldsPopup.indexOf('woonoppervlakte') >= 0) {
		const elementArray = [];
		const supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('2'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Woonoppervlakte', kavel.woonoppervlakte, false, elementArray));
	}
	if (kavel.inhoud && this.options.fieldsPopup.indexOf('inhoud') >= 0) {
		const elementArray = [];
		const supElement = document.createElement('sup');
		supElement.appendChild(document.createTextNode('3'));
		elementArray.push(document.createTextNode(' m'), supElement);

		tableElement.appendChild(this.createInfoRow('Inhoud', kavel.inhoud, false, elementArray));
	}
	if (kavel.tuinligging && kavel.woningsoort && kavel.woningsoort.toLowerCase() === 'appartement') {
		tableElement.appendChild(this.createInfoRow('Oriëntatie buitenruimte', kavel.tuinligging));
	}
	else if (kavel.tuinligging) {
		tableElement.appendChild(this.createInfoRow('Tuinligging', kavel.tuinligging));
	}

	if (kavel.prijsVan && kavel.prijsTot && this.options.fieldsPopup.indexOf('prijsbereik') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijsrange', '€' + String.fromCharCode(160) + kavel.prijsVan + ' - €' + String.fromCharCode(160) + kavel.prijsTot));
	}

	if (kavel.priceRange && this.options.fields.indexOf('prijsbereik') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijsrange', '€' + String.fromCharCode(160) + kavel.priceRange.from + ' - €' + String.fromCharCode(160) + kavel.priceRange.to + String.fromCharCode(160) + kavel.priceCompositionSuffix));
	}

	if (kavel.extra && this.options.fieldsPopup.indexOf('prijsbereik') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijsrange', kavel.extra));
	}

	if (parseInt(kavel.price, 10) > 0 && this.options.fieldsPopup.indexOf('prijs') >= 0) {
		tableElement.appendChild(this.createInfoRow('Prijs', kavel.priceFormattedWithComposition));
	}
	if (kavel.status && this.options.fieldsPopup.indexOf('status') >= 0) {
		tableElement.appendChild(this.createInfoRow('Status', kavel.status.label, false, false, kavel.status.value));
	}

	contentContainerElement.appendChild(tableElement);

	this.carouselSlider = false;

	var images = kavel.images.length > 0 ? kavel.images : kavel.houseModel.images;

	if (images && CarouselSlider){
		var carouselElement = document.createElement('div');
		carouselElement.setAttribute('class', 'kavelkaart-fullinfowindow-carousel');

		var carouselIndicatorElement = document.createElement('div');
		carouselIndicatorElement.setAttribute('class', 'kavelkaart-fullinfowindow-indicator');
		carouselElement.appendChild(carouselIndicatorElement);

		var carouselSlidesElement = document.createElement('div');
		carouselSlidesElement.setAttribute('class', 'kavelkaart-fullinfowindow-slides');
		carouselElement.appendChild(carouselSlidesElement);

		for (let i=0;i<images.length;i++){
			if (images[i].featured){
				continue;
			}

			let imageBig = document.createElement('a');
			imageBig.setAttribute('href', images[i].src);
			imageBig.setAttribute('style', 'background-image:url(' + images[i].src + ');');
			imageBig.setAttribute('class', 'kavelkaart-fullinfowindow-slide');

			carouselSlidesElement.appendChild(imageBig);
		}

		const options = {
			'autoDelay' : 6000
		};

		this.carouselSlider = new CarouselSlider(carouselElement, options, carouselSlidesElement, carouselIndicatorElement, false, true);

		contentContainerElement.appendChild(carouselElement);
	}

	if (kavel.omschrijvingHtml && kavel.omschrijvingHtml.trim().length > 0){
		const omschrijvingContainer = document.createElement('div');
		omschrijvingContainer.setAttribute('class', 'kavelkaart-fullinfowindow-description');

		const omschrijvingHtml = this.stripScripts(kavel.omschrijvingHtml);
		omschrijvingContainer.innerHTML = omschrijvingHtml;

		contentContainerElement.appendChild(omschrijvingContainer);
	}

	//documenten
	if (this.options.showDocuments){
		var documenten = [];

		if (kavel.houseModel?.documents){
			var documenten = documenten.concat(kavel.houseModel.documents);
		}

		if (kavel.documents){
			var documenten = documenten.concat(kavel.documents);
		}

		if (kavel.projectDocumenten){
			var documenten = documenten.concat(kavel.projectDocumenten);
		}

		if (documenten){
			var documentenContainerElement = document.createElement('div');
			documentenContainerElement.setAttribute('class', 'kavelkaart-fullinfowindow-documents');

			var docWoningtypesTitleElement = document.createElement('div');
			docWoningtypesTitleElement.setAttribute('class', 'kavelkaart-fullinfowindow-title');

			docWoningtypesTitleElement.appendChild(document.createTextNode('Downloads'));

			documentenContainerElement.appendChild(docWoningtypesTitleElement);

			var docWoningtypesListElement = document.createElement('ul');
			docWoningtypesListElement.setAttribute('class', 'kavelkaart-fullinfowindow-documents-container');

			for (var i=0;i<documenten.length;i++){
				var docWoningtypesListItem = document.createElement('li');
				docWoningtypesListItem.setAttribute('class', 'kavelkaart-fullinfowindow-documents-item');

				var docWoningtypesListItemLink = document.createElement('a');
				docWoningtypesListItemLink.setAttribute('title', documenten[i].fileName);
				docWoningtypesListItemLink.setAttribute('href', documenten[i].src);
				docWoningtypesListItemLink.setAttribute('target', '_blank');

				var name = documenten[i].fileName;
				if (documenten[i].name){
					name = documenten[i].name;
				}

				docWoningtypesListItemLink.appendChild(document.createTextNode(name));

				docWoningtypesListItem.appendChild(docWoningtypesListItemLink);

				docWoningtypesListElement.appendChild(docWoningtypesListItem);
			}

			documentenContainerElement.appendChild(docWoningtypesListElement);

			contentContainerElement.appendChild(documentenContainerElement);
		}
	}

	contentElement.appendChild(contentContainerElement);

	//button selecteer woning
	if (this.options.buttonPopup){
		var buttonElement = document.createElement('a');
		buttonElement.setAttribute('class', 'button kavelkaart-fullinfowindow-button');
		buttonElement.setAttribute('data-buttontype', 'woningvoorkeur');
		buttonElement.setAttribute('data-bouwnummer', kavel.bouwnummer);

		if (this.options.buttonPopup.target){
			buttonElement.setAttribute('target', this.options.buttonPopup.target);
		}

		if (kavel.uuid){
			var id = kavel.uuid;
		}
		else {
			var id = kavel.bouwnummer;
		}

		var urlParts = this.options.buttonPopup.link.split('#');
		if (urlParts.length > 1){
			var hash = urlParts[urlParts.length-1];

			urlParts.splice(urlParts.length-1, 1);
			var url = urlParts.join();
			var url = url.replace(/\/$/, '') + '?bouwnummer=' + id + '#' + hash;
		}
		else {
			var url = this.options.buttonPopup.link + '?bouwnummer=' + id;
		}

		buttonElement.setAttribute('href', url);
		buttonElement.appendChild(document.createTextNode(this.options.buttonPopup.text));

		contentElement.appendChild(buttonElement);
	}

	const closeElement = document.createElement('button');
	closeElement.setAttribute('class', 'kavelkaart-fullinfowindow-close');
	closeElement.addEventListener('click', this.removeFullInfoWindow);
	contentElement.appendChild(closeElement);

	this.fullInfoWindowElement.appendChild(contentElement);
};

SituatieKaart.prototype.removeFullInfoWindow = function(e){
	this.fullInfoWindowElement.classList.remove('is-active');
	this.fullInfoWindowBackgroundElement.classList.remove('is-active');
};

SituatieKaart.prototype.toggleLotStatusVisibility = function(status) {
	for (let i=0;i<this.bouwnummers.length;i++){
		if (status === this.bouwnummers[i].element.getAttribute('data-status')) {
			if (this.bouwnummers[i].element.getAttribute('class').match(/is-active/)){
				this.bouwnummers[i].element.setAttribute('class', this.bouwnummers[i].element.getAttribute('class').replace('is-active', '').trim());
			}
			else {
				this.bouwnummers[i].element.setAttribute('class', 'is-active ' + this.bouwnummers[i].element.getAttribute('class'));
			}
		}
	}
};

//TODO: function to long, needs refactor
SituatieKaart.prototype.openViewer = function(){
	this.viewerElement = document.createElement('div');
	this.viewerElement.setAttribute('class', 'vanillelightbox-viewer is-active kavelkaart');

	this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\')');

	var imgElement = document.createElement('img');

	imgElement.addEventListener('load', event => {
		if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth){

			this.mapWidth = event.target.width * .5;
			this.mapHeight = event.target.height * .5;

			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('width', this.mapWidth);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('height', this.mapHeight);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('x', 0);
			this.htmlElements.mapElement.getElementsByTagName('svg')[0].setAttribute('y', 0);

			window.addEventListener('resize', this.onResize);
			this.onResize();
		}
		else {
			if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')){
				this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-interactievekaart') + '\');');
			}
			else {
				this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\');');
			}
		}
	}, false);

	if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')){
		imgElement.setAttribute('src', this.htmlElements.kaartElement.getAttribute('data-interactievekaart'));
	}
	else {
		imgElement.setAttribute('src', this.htmlElements.kaartElement.getAttribute('data-href'));
	}

	//infowindow aanmaken
	this.infoWindowElement = document.createElement('div');
	this.infoWindowElement.setAttribute('class', 'infowindow');

	this.htmlElements.navigationElement.appendChild(this.infoWindowElement);

	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth){

		this.viewerElement.appendChild(this.htmlElements.mapElement);

		this.viewerElement.addEventListener('click', e => {
			if (e.target == this.viewerElement) {
				this.removeViewer();
			}
		}, false);

		var closeElement = document.createElement('button');
		closeElement.setAttribute('class', 'vanillelightbox-viewer-button-close');
		closeElement.addEventListener('click', this.removeViewer);
		this.viewerElement.appendChild(closeElement);

		this.viewerElement.appendChild(this.htmlElements.navigationElement);

		document.body.appendChild(this.viewerElement);
	}
	else {
		this.htmlElements.kaartElement.classList.contains('is-active');

		while (this.htmlElements.kaartElement.firstChild){
			this.htmlElements.kaartElement.removeChild(this.htmlElements.kaartElement.firstChild);
		}
		this.htmlElements.kaartElement.appendChild(this.htmlElements.mapElement);
	}

	//legenda aanmaken

	if (this.options.showLegenda) {
		// get all unique statuses from bouwnummers
		const statuses = this.bouwnummers.map(bouwnummer => bouwnummer.data.status).filter((value, index, self) => (
			self.findIndex(status => status.value === value.value) === index
		));

		const lotStateFilter = new LotStateFilter(statuses.map(status => (
			{
				status,
				isActive: (this.options.defaultLegendaStatus === 'available-active' && (status.value === 'available' || status.value === 'te koop') || this.options.defaultLegendaStatus === 'active')
			}
		)));
		const lotStateFilterContainer = lotStateFilter.createHtml(this.toggleLotStatusVisibility);

		if (lotStateFilterContainer.nodeType == 1) {
			this.htmlElements.navigationElement.appendChild(lotStateFilterContainer);
		}
	}
};

SituatieKaart.prototype.onResize = function(){
	if (this.viewerElement.offsetWidth > this.mapWidth){
		var width = ' margin-left: -' + this.mapWidth  / 2 + 'px; left: 50%; width: ' + this.mapWidth + 'px;';
	}
	else {
		var width = 'left: 0; width: ' + this.mapWidth + 'px;';
	}
	if (this.viewerElement.offsetHeight > this.mapHeight){
		var height = ' margin-top: -' + this.mapHeight  / 2 + 'px; top: 50%; height: ' + this.mapHeight + 'px;';
	}
	else {
		var height = 'top: 0; height: ' + this.mapHeight + 'px;';
	}

	if (this.htmlElements.kaartElement.getAttribute('data-interactievekaart')){
		this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-interactievekaart') + '\');' + width + height);
	}
	else {
		this.htmlElements.mapElement.setAttribute('style', 'background-image: url(\'' + this.htmlElements.kaartElement.getAttribute('data-href') + '\');' + width + height);
	}
};

SituatieKaart.prototype.onResizeLayout = function(){
	if (window.innerWidth && window.innerWidth < this.options.layoutSwitchWidth && this.currentLayout == 'large' || window.innerWidth && window.innerWidth > this.options.layoutSwitchWidth && this.currentLayout == 'small'){
		window.location.href = window.location.href;//simpele fix maar kan beter
	}
};

SituatieKaart.prototype.removeViewer = function(){
	this.viewerElement.parentNode.removeChild(this.viewerElement);
	this.infoWindowElement.parentNode.removeChild(this.infoWindowElement);
	this.viewerElement = null;
	this.infoWindowElement = null;
};

SituatieKaart.prototype.stripScripts = function(htmlString){
	var div = document.createElement('div');
	div.innerHTML = htmlString;
	var scripts = div.getElementsByTagName('script');
	var i = scripts.length;
	while (i--) {
		scripts[i].parentNode.removeChild(scripts[i]);
	}
	return div.innerHTML;
};

export default SituatieKaart;